import * as React from "react";
import { Props } from "../../types/global";
import { AuthService } from "./auth-service";
import { AuthHeader } from "./AuthHeader";
import { messageDialog } from "../dialogs/MessageDialog";
import { dialogService } from "react-api-dialog";
import { isEmail } from "../utils";
import t from "../i18n";
import { LoginWithAnalytics } from ".";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";

declare type ForgotPasswordState = {
    email: string,
    errorMessage?: string,
    isResetDone: boolean,
}
export default class ForgotPassword extends React.Component<Props, ForgotPasswordState> {
    readonly state: ForgotPasswordState = { email: "", isResetDone: false };
    showMessage = (message: string, title: string) => {
        if (this.props.ok) {
            alert(message);
        } else {
            messageDialog(message, title);
        }
    }
    showLogin = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(LoginWithAnalytics, "/login");
        } else {
            this.props.history.push("/login");
        }
    }
    validate = () => {
        if (!this.state.email) {
            this.setState({ errorMessage: t.validations("valid_email") });
            return false;
        }
        if (!isEmail(this.state.email)) {
            this.setState({ errorMessage: t.validations("valid_email") });
            return false;
        }
        return true;
    }
    resetPassword = async () => {
        if (!this.validate()) return;
        dialogService.showPreloader();
        const response = await AuthService.forgotPassword(this.state.email);
        await dialogService.hidePreloader();
        if (response.responseCode === 0) {
            this.setState({ isResetDone: true });
        } else {
            this.showMessage(response.responseMessage, t.common("oops"));
        }
    }
    cancelReset = () => {
        if (this.props.cancel) this.props.cancel();
        else this.props.history.push("/login");
    }
    renderForgotPassword() {
        if (this.state.isResetDone) return null;
        return <React.Fragment>
            <AuthHeader text={t.menu("forgot_password")} showLogo={!!this.props.ok} />
            <div className="form-group">
                <h5>{t.topup("user_name_label")}:</h5>
                <input type="text" className="form-control" value={this.state.email} onChange={e => this.setState({ email: e.target.value })} maxLength={100} />
                {!!this.state.errorMessage && <div className="red-text">{this.state.errorMessage}</div>}
            </div>
            <div className="form-group text-right">
                <a className="button white text-center" onClick={this.cancelReset}>{t.common("cancel_button")}</a>
                <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.resetPassword}>{t.login("reset_password")}</a>
            </div>
        </React.Fragment>
    }
    renderForgotPasswordConfirmation() {
        if (!this.state.isResetDone) return null;
        return <React.Fragment>
            <AuthHeader text={t.menu("forgot_password_confirm")} showLogo={!!this.props.ok} />
            <div className="form-group">
                <div style={{ marginBottom: 20 }}>
                    {t.messages("reset_password_email_1")}
                    <div style={{ height: 10 }} />
                    {t.messages("reset_password_email_2")}
                </div>
            </div>
            <div className="form-group text-right">
                <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.showLogin}>{t.login("preceed_to_login")}</a>
            </div>
        </React.Fragment>
    }
    render() {
        return (
            <div className="auth container">
                <div className="auth-box">
                    {this.renderForgotPassword()}
                    {this.renderForgotPasswordConfirmation()}
                </div>
            </div>
        );
    }
}